const SocialMediaIcons = () => {
  return (
    <div className="flex justify-center md:justify-start my-10 gap-7">
      <a
        className="hover:opacity-50 transition duration-500"
        href="https://www.linkedin.com/in/raunac00/"
        target="_blank"
        rel="noreferrer"
      >
        <img alt="linkedin-link" src="../assets/link.png" />
      </a>
      <a
        className="hover:opacity-50 transition duration-500"
        href="https://github.com/Raunakkushwaha"
        target="_blank"
        rel="noreferrer"
      >
        <img alt="twitter-link" src="../assets/git.png" />
      </a>
      <a
        className="hover:opacity-50 transition duration-500"
        href="https://www.instagram.com"
        target="_blank"
        rel="noreferrer"
      >
        <img alt="facebook-link" src="../assets/ig.png" />
      </a>
      <a
        className="hover:opacity-50 transition duration-500"
        href="mailto:raunakkushwaha85@gmail.com"
        target="_blank"
        rel="noreferrer"
      >
        <img alt="instagram-link" src="../assets/mail.png" />
      </a>

      <a
        className="hover:opacity-50 transition duration-500"
        href="https://drive.google.com/file/d/12shnePaq2o7TFZH8gJMHIKfZtVR8rT3k/view?usp=sharing"
        target="_blank"
        rel="noreferrer"
      >
        <img alt="instagram-link" src="../assets/resume.png" />
      </a>




    </div>
  );
};

export default SocialMediaIcons;
